import { Component, EventEmitter, OnChanges, OnDestroy, OnInit, Output, input, model, output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog'
import { Router } from '@angular/router';
import { faTrash, faWarning, faCircleInfo, faCopy, faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { faCircleXmark } from '@fortawesome/free-regular-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Editor, Toolbar } from 'ngx-editor';
import { ReportService } from 'src/app/services/report.service';
import { ReportForest } from 'src/app/models/reportForest.model';
import { ForestTreament } from 'src/app/models/forestTreatment.model';
import { ConfirmationToastComponent } from 'src/app/components/confirmation-toast/confirmation-toast.component';
import { DeleteTreatmentComponent } from './delete-treatment/delete-treatment.component';
import { APP_CONSTANTS } from 'src/app/shared/app.constants';
import { MatAccordion } from '@angular/material/expansion';
import { AutoSaveComponent } from '../auto-save/auto-save.component';
import { TreamentSpecification } from 'src/app/models/forestSpecification.model';

@Component({
    selector: 'app-recommended-treatment',
    templateUrl: './recommended-treatment.component.html',
    styleUrls: ['./recommended-treatment.component.scss'],
    standalone: false
})


export class RecommendedTreatmentComponent extends AutoSaveComponent implements OnChanges, OnInit, OnDestroy {

  faTrash = faTrash;
  faWarning = faWarning;
  faCircleInfo = faCircleInfo;
  faCopy = faCopy;
  faArrowUpRightFromSquare = faArrowUpRightFromSquare;
  faCircleXmark = faCircleXmark as IconProp;

  toolbar: Toolbar = APP_CONSTANTS.EDITOR_TOOLBAR;

  editors: Editor[] = [];

  report = input.required<any>();
  nav = model.required<string>();
  status = output<number | undefined>();
  errorList: string[] = [];
  forests: any[] = []
  treatments: any[][] = [];
  fromGIS: boolean = false;
  page = input("5");
  @Output() loaded = new EventEmitter();

  reg = APP_CONSTANTS.URL_REGEX;

  treatmentTypes: any[] = []
  treatmentOptionNameMap: Map<number, string> = new Map<number, string>();

  im = new Inputmask("currency", {
    groupSeparator: ',',
    prefix: '$',
    allowMinus: false
  });

  constructor(
    public dialog: MatDialog,
    private readonly router: Router,
    private readonly formBuilder: FormBuilder,
    public readonly reportService: ReportService,
    public readonly toast: ConfirmationToastComponent,
  ) {
    super()
    this.initTreamentOptions()
  }

  ngOnInit(): void {
    this.status.emit(undefined);
    this.forests = this.report().forests
    this.forests?.forEach((forest: ReportForest) => {

      this.treatments.push([])

      forest.treatments?.forEach((treatment: ForestTreament) => {
        let formGroup = this.formBuilder.group({
          treatment_type: [treatment.treatment_type_id],
          treatment_option: [treatment.treatment_option_id],
        });

        let specs: any[] = []
        treatment.treatment_specifications?.forEach((spec: TreamentSpecification) => {
          if (spec.from_GIS) this.fromGIS = true;
          let form = this.formBuilder.group({
            specification_name: [spec.specification_name, Validators.maxLength(40)],
            specification_number: [spec.specification_number],
            unit_cost: [spec.unit_cost],
            custom_unit_qty: [spec.custom_unit_qty],
            treatment_off_nfs_land: [spec.treatment_off_nfs_land],
            treatment_outside_fire: [spec.treatment_outside_fire],
            treatment_narrative: [this.customATOB(spec.treatment_narrative ?? ""), Validators.maxLength(6000)],
            specification_sheet: [decodeURI(spec.specification_sheet ?? ''), [Validators.pattern(this.reg), Validators.maxLength(500)]],
            override_GIS_qty: [(spec.custom_unit_qty ?? 0) != 0],
            from_GIS: [spec.from_GIS],
          })
          this.listenForChanges(form)
          specs.push({
            form: form,
            treatment_specification_id: spec.treatment_specification_id,
            gis_unit_qty: spec.gis_unit_qty,
            editor: new Editor(),
          })
        })
        this.listenForChanges(formGroup)

        this.treatments[this.treatments.length - 1].push({
          form: formGroup,
          specs: specs,
          new: !treatment.from_GIS,
          forest_treatment_id: treatment.forest_treatment_id,
          specification_number: treatment.specification_number,
          treatment_option_id: treatment.treatment_option_id
        })
      })
    })
    this.treatments.forEach((treatments: any, index: number) => { //per forest
      treatments.sort((a: any, b: any) => a.specification_number < b.specification_number ? -1 : 1);
      treatments.sort((a: any, b: any) => a.treatment_option_id < b.treatment_option_id ? -1 : 1);

      if (index >= 1) { //skip first forest
        treatments.forEach((treatment: any) => { //find matching treatments
          this.findMatching(treatment, index);
        });
      }
    })
  }

  findMatching(treatment: any, index: number) {
    let matchRecord: any = null;
    this.treatments.forEach((treatments2: any, index2: number) => {
      if (index2 != index) { //ignore own forest
        matchRecord = treatments2.find((x: any) => x.form.value.treatment_option == treatment.form.value.treatment_option && x.specs[0].form.value.specification_number == treatment.specs[0].form.value.specification_number)?.forest_treatment_id;
      }
    });
    treatment.matchRecord = matchRecord;
  }

  copyTreatment(treament: any) {
    let matchingTreatment: any;
    this.treatments.forEach((treatments2: any, index2: number) => {
      if (matchingTreatment) return;
      matchingTreatment = treatments2.find((x: any) => x.forest_treatment_id == treament.matchRecord);
    });
    treament.specs[0].form.patchValue({
      unit_cost: matchingTreatment.specs[0].form.value.unit_cost,
      treatment_narrative: matchingTreatment.specs[0].form.value.treatment_narrative,
      specification_sheet: matchingTreatment.specs[0].form.value.specification_sheet
    })
  }

  ngOnChanges(): void {
    if (this.nav() != '') this.navigate();
  }

  navigate() {
    this.save(true)
  }

  route() {
    switch (this.nav()) {
      case 'forward': {
        this.router.navigate(['/2500-8-report'], { queryParams: { report_id: this.report().report_id, report_page_input: +this.page() + 1 } });
        break;
      }
      case 'back': {
        this.router.navigate(['/2500-8-report'], { queryParams: { report_id: this.report().report_id, report_page_input: +this.page() - 1 } });
        break;
      }
      case 'close': {
        this.router.navigate(['fire-overview'], { queryParams: { assessment_id: this.report().assessment_id } });
        break;
      }
      default: {
        if (Number(this.nav()))
          this.router.navigate(['/2500-8-report'], { queryParams: { report_id: this.report().report_id, report_page_input: this.nav() } });
        break;
      }
    }
  }

  getReportForests(): [ReportForest[], boolean] {
    let reportForests: ReportForest[] = []
    let index = 0;
    let allFieldsFilled = true

    this.forests.forEach((forest: ReportForest) => {
      let newForest: ReportForest = {
        forest_id: forest.forest_id,
        treatments: [] as ForestTreament[],
      }
      this.treatments[index].forEach((item: any) => {
        let specs: any[] = []
        if (item.forest_treatment_id == -1) {
          allFieldsFilled = false
        }
        if (item.form.value.treatment_option == -1) {
          allFieldsFilled = false
        }
        item.specs.forEach((spec: any) => {
          if (spec.form.value.unit_cost == null) {
            allFieldsFilled = false
          }
          if ((spec.form.value.override_GIS_qty || !spec.form.value.from_GIS) && spec.form.value.custom_unit_qty == null) allFieldsFilled = false;
          if (spec.form.value.specification_number != 1 && spec.form.value.specification_name == '') allFieldsFilled = false;
          if (spec.form.pristine) return // ignore specs that are not dirty
          let custom_unit_qty = spec.form.value.custom_unit_qty;
          if (spec.form.value.override_GIS_qty && custom_unit_qty == '') {
            custom_unit_qty = null;
            allFieldsFilled = false;
          }
          if (!spec.form.override_GIS_qty && spec.form.value.from_GIS) custom_unit_qty = null;
          let unit_cost = spec.form.value.unit_cost;
          if (unit_cost == '') {
            unit_cost = null;
            allFieldsFilled = false;
          }
          let newSpec: any = {
            treatment_specification_id: spec.treatment_specification_id,
            specification_number: spec.form.value.specification_number,
            unit_cost: unit_cost,
            custom_unit_qty: custom_unit_qty,
            treatment_off_nfs_land: spec.form.value.treatment_off_nfs_land,
            treatment_outside_fire: spec.form.value.treatment_outside_fire,
            from_GIS: spec.form.value.from_GIS,
          }
          let treatment_narrative: any = this.customBTOA(spec.form.value.treatment_narrative)
          if (!spec.form.controls.treatment_narrative.invalid) { // invalid here means db won't accept
            newSpec.treatment_narrative = treatment_narrative
          }
          if (!spec.form.controls.specification_name.invalid) { // invalid here means db won't accept
            newSpec.specification_name = spec.form.value.specification_name
          }
          if (!spec.form.controls.specification_sheet.invalid) { // invalid here means db won't accept
            newSpec.specification_sheet = encodeURI(spec.form.value.specification_sheet)
          }
          specs.push(newSpec)
        })
        if (specs.length == 0 && !item.form.dirty) return // ignore untouched treatments
        newForest.treatments!.push({
          forest_id: forest.forest_id,
          forest_treatment_id: item.forest_treatment_id == -1 ? null : item.forest_treatment_id,
          // unit_qty: item.form.value.unit_qty || item.gis_qty,
          treatment_type_id: item.form.value.treatment_type?.treatment_type_id,
          treatment_option_id: item.form.value.treatment_option == -1 ? null : item.form.value.treatment_option,
          treatment_specifications: specs,
        })
      })
      reportForests.push(newForest)

      index += 1
    })

    return [reportForests, allFieldsFilled]
  }

  override save(navigate?: boolean) {
    this.navDebounceCheck(navigate)

    let [reportForests, allFieldsFilled] = this.getReportForests()

    if (!navigate && this.checkIfNotNeedToSave(reportForests)) return
    this.status.emit(allFieldsFilled ? 2 : 1);

    this.reportService.updateReport({
      report_id: this.report().report_id,
      forests: reportForests,
      [`page_${this.page()}_status_id`]: allFieldsFilled ? 2 : 1,
    }).subscribe({
      next: (response) => {
        if (navigate) {
          if (this.nav() == "forward" && !allFieldsFilled) {
            this.errorList = [];
            this.forests.forEach((forest: ReportForest, index) => {
              this.setErrorList(index, forest);
            })
            window.scrollTo({ top: 0, behavior: 'smooth' });
            this.nav.set('');
            this.postSave();
          } else
            this.route() // navigate route after save because next page needs to see this page's changes
        } else {
          this.postSave()
        }
      },
      error: (response) => {
        this.toast.openErrorSnackBar(`There was an error saving the report`, "Please try again.");
      },
      complete: () => {
        if (navigate) this.navDebounce = false
      }
    })
  }

  setErrorList(index: number, forest: any) {
    this.treatments[index].forEach((item: any, treat_index) => {
      item.form.markAllAsTouched();
      for (let field in item.form.controls) {
        const control = item.form.get(field);
        if (control?.invalid) {
          this.errorList.push(forest.forest_name + ' - ' + (treat_index + 1) + ' - ' + field.replaceAll('_', ' '));
        }
      }
      item.specs.forEach((spec: any) => {
        spec.form.markAllAsTouched();
        for (let field in spec.form.controls) {
          const control = spec.form.get(field);
          if (control?.invalid) {
            this.errorList.push(forest.forest_name + ' - ' + (treat_index + 1) + ' - ' + field.replaceAll('_', ' '));
          }
        }
      })
    })
  }

  save_close() {
    this.save(true);
    this.router.navigate(['fire-overview'], { queryParams: { assessment_id: this.report().assessment_id } });
  }

  treatmentTypeSelected(event: any, treatment: any) {
    treatment.type = event.value
  }

  standardTreatmentSelected(event: any, treatment: any, forest_index: number) {
    if (!treatment.specs[0].form.value.from_GIS && treatment.new) { //if new record and treatment already exists, iterate spec num
      let treatments = this.treatments[forest_index].filter((x: any) => x.forest_treatment_id != treatment.forest_treatment_id && x.form.value.treatment_option == treatment.form.value.treatment_option_id)
      if (treatments.length > 0) {
        let spec_num = treatments[treatments.length - 1].specification_number + 1;
        this.treatments[forest_index].find((x: any) => x.forest_treatment_id == treatment.forest_treatment_id && x.form.value.treatment_option_id == treatment.form.value.treatment_option_id).specs[0].form.patchValue({ specification_number: spec_num })
      }
    }
    if (forest_index > 0) this.findMatching(treatment, forest_index);

    treatment.standardTreatment = event.value
  }

  addNewTreatment(forestIndex: number) {
    let data = {
      unit_cost: 0,
      forest_id: this.forests[forestIndex].forest_id,
      override_unit_qty: true,
      treatment_type_id: null,
      treatment_option_id: null
    }
    this.reportService.createFireTreatment(data).subscribe((resp) => {

      let formGroup = this.formBuilder.group({
        unit_cost: [0],
        link: ["", [Validators.pattern(this.reg), Validators.maxLength(500)]],
        custom_qty: [0],
        override_GIS_qty: [true],
        treatment_type: [null],
        treatment_option: [null],
      });
      this.listenForChanges(formGroup)

      let newTreatment = {
        forest_treatment_id: resp.forest_treatment_id,
        form: formGroup,
        editor: new Editor(),
        specs: [],
        new: true,
      }
      this.addNewSpec(newTreatment)
      this.treatments[forestIndex].push(newTreatment);
    })
  }

  addNewSpec(treatment: any) {
    let data = {
      forest_treatment_id: treatment.forest_treatment_id,
      specification_name: "",
      specification_number: treatment.specs.length + 1,
      unit_cost: null,
      custom_unit_qty: null,
      treatment_narrative: "",
      specification_sheet: "",
      override_GIS_qty: true,
      gis_unit_qty: treatment.gis_unit_qty,
      from_GIS: false,
    }
    this.reportService.createSpec(data).subscribe((resp) => {
      let form = this.formBuilder.group({
        specification_name: ["", Validators.maxLength(100)],
        specification_number: [treatment.specs.length + 1],
        unit_cost: [null],
        custom_unit_qty: [null],
        treatment_off_nfs_land: [null],
        treatment_outside_fire: [null],
        treatment_narrative: [""],
        specification_sheet: ["", [Validators.pattern(this.reg), Validators.maxLength(500)]],
        override_GIS_qty: [true],
        gis_unit_qty: [treatment.gis_unit_qty],
        from_GIS: [false],
      })
      this.listenForChanges(form)

      treatment.specs.push({
        treatment_specification_id: resp.treatment_specification_id,
        form: form,
        editor: new Editor(),
      })
    });
  }

  deleteTreatment(forestIndex: number, treatmentIndex: number, treatment_id: any) {
    let treatment = this.treatments[forestIndex][treatmentIndex]

    if (treatment_id) {
      if (treatment.new) {
        this.reportService.deleteFireTreatment(treatment_id).subscribe((resp: any) => {
          this.treatments[forestIndex].splice(treatmentIndex, 1);
        });
      } else {
        this.dialog.open(DeleteTreatmentComponent, {
          width: "440px",
          panelClass: ['animate__animated', 'animate__fadeInDown'],
          data: {}
        }).afterClosed().subscribe((confirmed) => {
          if (confirmed) {
            this.reportService.deleteFireTreatment(treatment_id).subscribe((resp: any) => {
              this.treatments[forestIndex].splice(treatmentIndex, 1);
            });
          }
        })
      }
    } else {
      this.treatments[forestIndex].splice(treatmentIndex, 1);
    }

  }

  countGISTreatments(forestIndex: number) {
    let count = 0
    this.treatments[forestIndex].forEach((treatment: any) => {
      if (!treatment.new) {
        count++;
      }
    })
    return count
  }

  countNewTreatments(forestIndex: number) {
    let count = 0
    this.treatments[forestIndex].forEach((treatment: any) => {
      if (treatment.new) {
        count++;
      }
    })
    return count
  }

  initTreamentOptions() {
    this.reportService.getTreatmentOptions().subscribe((response) => {
      this.treatmentTypes = []
      response.forEach((item: any) => {
        this.treatmentOptionNameMap.set(item.treatment_option_id, item.treatment_option)
        let existingTreatment = this.treatmentTypes.find((x: any) => x.type == item.treatment_type.treatment_type)
        if (existingTreatment) {
          existingTreatment.standardTreatments.push(item)
        } else {
          this.treatmentTypes.push({
            type: item.treatment_type.treatment_type,
            standardTreatments: [item],
            treatment_type_id: item.treatment_type_id,
            unit_of_measure: item.unit_of_measure,
          })
        }
      })
      this.updateTreatmentValues()
    })
  }

  updateTreatmentValues() {
    this.treatments.forEach((forest: any) => {
      forest.forEach((treament: any) => {
        let treatmentType = this.treatmentTypes.find(
          (treatType: any) => treatType.treatment_type_id == treament.form.value.treatment_type
        )
        treament.form.patchValue({
          treatment_type: treatmentType
        })
        treament.type = treatmentType
      })
    })

    this.formReady = true;
    this.loaded.emit(true)
  }

  customATOB(s: string): string {
    try {
      return atob(s)
    } catch (err) {
      if (err) {
        return s
      }
    }
    return s
  }

  customBTOA(s: string): string {
    return btoa(s.replaceAll(/[\u00A0-\u2666]/g, function (c) {
      return '&#' + c.codePointAt(0) + ';';
    }));
  }

  removeSpec(forest_index: any, treatment_index: any, spec_index: any, spec_id: any) {
    if (spec_id)
      this.reportService.deleteSpec(spec_id).subscribe((resp: any) => {
        this.treatments[forest_index][treatment_index].specs.splice(spec_index, 1);
      });
    else
      this.treatments[forest_index][treatment_index].specs.splice(spec_index, 1);
  }

  onTreatmentClick(event: MouseEvent, accordion: MatAccordion): void {
    if (event.ctrlKey) {
      if (accordion._stateChanges.closed) {
        accordion.openAll();
        accordion._stateChanges.closed = false;

      }
      else {
        accordion.closeAll();
        accordion._stateChanges.closed = true;
      }
    }
  }

  onTreatmentKeypress(event: any, accordion: MatAccordion): void {
    if (event.ctrlKey && event.key === "Enter") {
      if (accordion._stateChanges.closed) {
        accordion.openAll();
        accordion._stateChanges.closed = false;

      }
      else {
        accordion.closeAll();
        accordion._stateChanges.closed = true;
      }
    }
  }
}
